export default __webpack_public_path__ + "static/media/megaYacht.9eda6ced.webp";